/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
class animatedBackgroundTextColors extends HTMLElement {
  constructor() {
    super();

    this.blocks = this.querySelectorAll('[data-announcement-block]');
    this.index = 1;
    this.interval;
  }

  connectedCallback() {
    this.blocks = Array.from(this.querySelectorAll('[data-announcement-block]'));
    this.index = 0;
  
    const matchedBlocks = this.getBlocksForCurrentPage();
    if (matchedBlocks.length > 0) {
      this.blocks.forEach(block => block.style.display = 'none');
      matchedBlocks.forEach(block => block.style.display = '');
      const firstBlock = matchedBlocks[0];
      if (firstBlock) {
        this.style.backgroundColor = firstBlock.dataset.backgroundColorBlock;
        this.style.color = firstBlock.dataset.frontColorBlock;
        firstBlock.classList.add('active');
      }
      this.visibleBlocks = matchedBlocks;
      this.init();
    }

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect.bind(this));
    }
  }

  // getBlocksForCurrentPage() {
  //   const currentPath = window.location.pathname;
  
  //   return this.blocks.filter(block => block.dataset.url === currentPath);
  // }
  getBlocksForCurrentPage() {
    const currentPath = window.location.pathname;
    const sanitizePath = str => str.replace(/\s+/g, '').replace(/\u200B/g, '').trim();
  
    const cleanCurrentPath = sanitizePath(currentPath);
  
    return this.blocks.filter(block => {
      const blockUrl = sanitizePath(block.dataset.url || '');
      const displayEverywhere = block.dataset.displayEverywhere === 'true';
  
      const notDisplay = (block.dataset.notDisplay || '')
        .split(',')
        .map(path => sanitizePath(path))
        .filter(path => path !== '');
  
      let blocked = false;
      for (let path of notDisplay) {
        if (path === cleanCurrentPath) {
          blocked = true;
          break;
        }
      }
  
      if (displayEverywhere) {
        return !blocked;
      }
  
      if (blocked) {
        return false;
      }
  
      return blockUrl === cleanCurrentPath;
    });
  }

  showBlockForCurrentPage() {
    const currentPath = window.location.pathname;
  
    for (let i = 0; i < this.blocks.length; i++) {
      const block = this.blocks[i];
      const blockUrl = block.dataset.url;
  
      if (blockUrl === currentPath) {
        this.blocks.forEach(b => b.classList.remove('active'));
  
        block.classList.add('active');
  
        this.style.backgroundColor = block.dataset.backgroundColorBlock;
        this.style.color = block.dataset.frontColorBlock;
  
        return true;
      }
    }
  
    return false;
  }
  
  init() {
    const blocksToAnimate = this.visibleBlocks || this.blocks;
    if (!blocksToAnimate || blocksToAnimate.length < 2) return;
    this.blocks = blocksToAnimate;
    this.interval = setInterval(this.changeColors.bind(this), 7000);
  }

  changeColors() {
    if (this.blocks.length < 2) return;
    // Get the new active block
    const activeBlock = this.blocks[this.index];
    
    // Get colors from the active block
    const backgroundColor = activeBlock.getAttribute('data-background-color-block');
    const frontColor = activeBlock.getAttribute('data-front-color-block');
    
    // Update component colors with active block colors
    setTimeout(() => {
      this.style.backgroundColor = backgroundColor;
      this.style.color = frontColor;
    }, 350);
    
    // Remove the 'active' class from the previous active block
    const prevActiveBlock = this.querySelector('[data-announcement-block].active');
    if (prevActiveBlock) prevActiveBlock.classList.remove('active');
    
    // Add the 'active' class to the new active block
    activeBlock.classList.add('active');

    // Update index
    this.index = (this.index + 1) % this.blocks.length;
  }

  handleBlockSelect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (!blockIndex) return;

    this.blocks.forEach(block => block.classList.remove('active'));

    e.target.classList.add('active');
    
    e.target.style.backgroundColor = e.target.getAttribute('data-background-color-block');
    e.target.style.color = e.target.getAttribute('data-front-color-block');
    e.target.style.transition = 'none';

    this.style.transition = 'none';
    this.style.backgroundColor = e.target.getAttribute('data-background-color-block');
    this.style.color = e.target.getAttribute('data-front-color-block');

    clearInterval(this.interval);
    this.index = parseInt(blockIndex);
  }

  handleBlockDeselect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (!blockIndex) return;

    e.target.style.backgroundColor = '';
    e.target.style.color = '';
    e.target.style.transition = '';

    this.style.transition = '';

    // Update index
    this.index = (parseInt(blockIndex) + 1) % this.blocks.length;
    this.init();
  }

}

customElements.define('animated-background-text-colors', animatedBackgroundTextColors);

/******/ })()
;